import { API, graphqlOperation } from "aws-amplify";

import { getApplicationQuery } from "./graphql/queries";

const getApplication = (id) =>
  API.graphql(graphqlOperation(getApplicationQuery, { id }));

export default getApplication;
